(() => {
  const dialog = document.querySelector('#sz-policy-dialog');
  const configNode = document.querySelector('#sz-policy-config');
  if (!dialog || !configNode) return;
  const config = JSON.parse(configNode.textContent);
  const root = window.Shopify?.routes?.root || '/';
  const checkbox = dialog.querySelector('[data-sz-policy-accept]');
  const save = dialog.querySelector('[data-sz-policy-save]');
  const error = dialog.querySelector('[data-sz-policy-error]');
  const list = dialog.querySelector('[data-sz-policy-items]');
  const terms = dialog.querySelector('[data-sz-policy-terms]').textContent.trim();
  const keys = ['sz_return_ack_v1', 'sz_policy_version', 'sz_policy_url', 'sz_policy_accepted_utc', 'sz_policy_items'];
  let pending = null, pendingForm = null, snapshot = '', busy = false, permit = false;
  // Use category metadata as well as the existing explicit policy tags.
  // Boundaries avoid matching Toyota, radiator caps, or card payment accessories.
  const categoryFinalSale = item => [item.productType || '', ...(item.collections || []), ...(item.tags || [])]
    .some(value => /(?:^|[\s_>\/-])(?:die[ -]?cast|collectibles?|collectables?|trading[ -]?cards?|tcg|toys?|apparel|clothing|t[ -]?shirts?|shirts?|hoodies?|sweatshirts?|headwear|hats?|jackets?|socks|pants|shorts)(?:$|[\s_>\/-])/i.test(value));
  const relevant = items => items.map(item => {
    const tags = [...(item.tags || [])];
    if (categoryFinalSale(item)) tags.push('SZ_POLICY_ACK_REQUIRED', 'SZ_POLICY_COLLECTIBLE_APPAREL');
    return {...item, tags:[...new Set(tags)].filter(tag => tag.startsWith('SZ_POLICY_')).sort()};
  }).filter(item => item.tags.includes('SZ_POLICY_ACK_REQUIRED'));
  const signature = items => JSON.stringify(items.map(({key, variant, quantity, tags}) => ({key, variant, quantity, tags})).sort((a,b) => a.key.localeCompare(b.key)));
  async function readItems() {
    const url = new URL(root, location.origin);
    url.searchParams.set('section_id', 'sz-policy-cart-data');
    url.searchParams.set('preview_theme_id', config.theme);
    url.searchParams.set('_policy', Date.now());
    const response = await fetch(url, {credentials:'same-origin', cache:'no-store'});
    if (!response.ok) throw Error(config.error);
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const data = JSON.parse(doc.querySelector('[data-sz-policy-cart]')?.textContent || 'null');
    if (!data || !Array.isArray(data.items)) throw Error(config.error);
    return relevant(data.items);
  }
  async function write(attributes) {
    const response = await fetch(root + 'cart/update.js', {method:'POST', credentials:'same-origin', headers:{'Content-Type':'application/json'}, body:JSON.stringify({attributes})});
    if (!response.ok) throw Error(config.error);
    const cart = await response.json();
    for (const [key,value] of Object.entries(attributes)) {
      if ((cart.attributes?.[key] || '') !== value) throw Error(config.error);
    }
  }
  function clear() { return write(Object.fromEntries(keys.map(key => [key,'']))); }
  function render(items) {
    list.replaceChildren();
    for (const item of items) {
      const li = document.createElement('li');
      const reasons = item.tags.map(tag => config.reasons[tag.replace('SZ_POLICY_','')]).filter(Boolean);
      li.textContent = `${item.title} × ${item.quantity} — ${reasons.join('; ')}`;
      list.append(li);
    }
    snapshot = signature(items); checkbox.checked = false; save.disabled = true;
  }
  function replay() {
    const action = pending; pending = null; dialog.close();
    const quantityFields = [...(pendingForm?.querySelectorAll('input[name="updates[]"]') || [])].filter(field => !field.disabled);
    quantityFields.forEach(field => {field.disabled = true;});
    permit = true;
    try { action?.(); } finally { setTimeout(() => {permit = false;quantityFields.forEach(field => {field.disabled = false;});}, 0); }
  }
  async function start(action, form) {
    if (busy || pending) return;
    busy = true; pending = action; pendingForm = form; error.textContent = config.loading;
    checkbox.checked = false; checkbox.disabled = true; save.disabled = true; list.replaceChildren();
    try {
      if (typeof window.szSmsConsentReview !== 'function') throw Error(config.error);
      await window.szSmsConsentReview();
      dialog.showModal();
      const items = await readItems(); await clear();
      if (!items.length) { replay(); return; }
      render(items); error.textContent = '';
    } catch (e) { pending = null; if (e.name !== 'AbortError') { error.textContent = config.error; if (!dialog.open) dialog.showModal(); } }
    finally { busy = false; checkbox.disabled = !pending; }
  }
  checkbox.addEventListener('change', () => { save.disabled = !checkbox.checked || busy || !pending; });
  save.addEventListener('click', async () => {
    if (!checkbox.checked || busy || !pending) return;
    busy = true; save.disabled = true; checkbox.disabled = true;
    try {
      const items = await readItems();
      if (!items.length) { await clear(); replay(); return; }
      if (signature(items) !== snapshot) { render(items); error.textContent = config.changed; return; }
      const attributes = {sz_return_ack_v1:terms, sz_policy_version:config.version, sz_policy_url:location.origin + root + 'pages/shipping-returns', sz_policy_accepted_utc:new Date().toISOString(), sz_policy_items:JSON.stringify(items.map(({id,variant,title,sku,quantity,tags}) => ({id,variant,title,sku,quantity,tags})))};
      await write(attributes);
      const fresh = await readItems();
      if (!fresh.length) { await clear(); replay(); return; }
      if (signature(fresh) !== snapshot) { await clear(); render(fresh); error.textContent = config.changed; return; }
      replay();
    } catch { error.textContent = config.error; }
    finally { busy = false; checkbox.disabled = false; save.disabled = !checkbox.checked || !pending; }
  });
  dialog.querySelector('[data-sz-policy-cancel]').addEventListener('click', () => { if (!busy) { pending = null; dialog.close(); } });
  dialog.addEventListener('cancel', event => { if (busy) event.preventDefault(); else pending = null; });
  window.addEventListener('click', event => {
    if (permit || !(event.target instanceof Element)) return;
    const target = event.target.closest('button[name="checkout"],input[name="checkout"],a[href],.checkout-cart-widget');
    if (!target || target.disabled || dialog.contains(target)) return;
    const checkoutLink = target.matches('a[href]') && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?checkouts?(?:\/|$)/.test(new URL(target.href, location.href).pathname);
    if (!checkoutLink && !target.matches('[name="checkout"],.checkout-cart-widget')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    void start(() => target.click(), target.closest('form'));
  }, true);
  window.addEventListener('submit', event => {
    if (permit || event.submitter?.name !== 'checkout') return;
    event.preventDefault(); event.stopImmediatePropagation();
    const form = event.target, submitter = event.submitter;
    void start(() => form.requestSubmit(submitter), form);
  }, true);
})();
